import { render, staticRenderFns } from "./relatorioEstoque.vue?vue&type=template&id=326c434d&scoped=true&"
import script from "./relatorioEstoque.vue?vue&type=script&lang=js&"
export * from "./relatorioEstoque.vue?vue&type=script&lang=js&"
import style0 from "./relatorioEstoque.vue?vue&type=style&index=0&id=326c434d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326c434d",
  null
  
)

export default component.exports